export enum SUBMISSION_TYPE_ENUM {
  newSite = 'New Site for Initial Review',
  newStudy = 'New Study for Initial Review',
  newStudyandSite = 'New Study and Site for Initial Review',
  clinicalUse = 'Clinical Use of Humanitarian Use Device (HUD)',

  // ERM-4385: Adding new submission types
  singlePatientAndSite = 'Single Patient Expanded Access (New Study+Site)',
  hudClinicalUseAndSite = 'HUD Clinical Use (New Study+Site)',
}
